<template lang="pug">
.take-max-height
    Error(:code="403" message="Unauthorized")
</template>

<script>
import Error from '@/components/Error'

export default {
    components: { Error },
    name: 'Unauthorized',
}
</script>

<style lang="sass" scoped>
    .take-max-height
        height: 50vh
        min-height: 100%
</style>
